import { render, staticRenderFns } from "./Infographic2.vue?vue&type=template&id=771ac21a&"
import script from "./Infographic2.vue?vue&type=script&lang=js&"
export * from "./Infographic2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports